// extracted by mini-css-extract-plugin
export var deleteModal = "_ge-0";